<template>
    <el-dialog
        title="新增券"
        v-model="po.show"
        append-to-body
        :close-on-click-modal="false"
        width="40%"
        :before-close="close"
    >
        <el-form :model="po.couponForm" ref="poFormRef" label-width="120px" :rules="rules">
            <el-form-item prop="type" label="类型">
                <el-select v-model="po.couponForm.type">
                    <el-option :key="item.value" :label="item.name" :value="item.value" v-for="item in po.types" />
                </el-select>
            </el-form-item>
            <el-form-item prop="sid" label="供应商" v-if="po.couponForm.type === 1">
                <el-select v-model="po.couponForm.sid" placeholder="请选择">
                    <el-option :key="item.id" :label="item.company_name" :value="item.id" v-for="item in po.supplies" />
                </el-select>
            </el-form-item>
            <el-form-item prop="money" label="面额">
                <el-input v-model="po.couponForm.money" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="num" label="发放数量">
                <el-input v-model="po.couponForm.num" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="timeRange" label="有效期">
                <el-date-picker
                    v-model="po.couponForm.timeRange"
                    type="daterange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="YYYY-MM-DD"
                />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';
import { Plus } from '@element-plus/icons-vue';
import { requestDomain } from '../../../package.json';
const props = defineProps({
    visible: Boolean,
    configInfo: Object,
    parentMenus: Array
});
const emit = defineEmits(['parentCallback', 'closeDialog']);
const uploadRef = ref();
const handleSuccess = e => {
    po.couponForm.imgUrl = e.url;
    uploadRef.value.clearFiles();
};

const poFormRef = ref();

const rules = reactive({
    num: [{ required: true, trigger: 'change', message: '请输入发放数量' }],
    money: [{ required: true, trigger: 'change', message: '请输入面额' }],
    sid: [{ required: true, trigger: 'change', message: '请选择供应商' }],
    timeRange: [{ type: 'array', required: true, trigger: 'change', message: '请选择有效时间' }]
});
let po = reactive({
    types: [
        {
            value: 0,
            name: '优惠券'
        },
        {
            value: 1,
            name: '代金券'
        }
    ],
    show: props.visible,
    couponForm: {
        type: 0,
        sid: '',
        num: '',
        money: '',
        timeRange: []
    },
    supplies: []
});

const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            po.couponForm.startDate = po.couponForm.timeRange[0];
            po.couponForm.endDate = po.couponForm.timeRange[1];
            const result = await request('addCoupon', po.couponForm);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
            emit('parentCallback');
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
const close = () => {
    emit('closeDialog');
};
const resetForm = poFormRef => {
    poFormRef.resetFields();
    close();
};
const queryInitHandler = async function () {
    const result = await request('queryUserLists', { level: 3 });
    const list = result.data.list;
    po.supplies = list;
};
queryInitHandler();
</script>
<style lang="scss">
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
.attachment-uploader .el-button {
    height: 100px;
    width: 100px;
    border: 1px dashed #cdd0d6;
}
</style>
